import { format } from 'date-fns';
import messages from '../translations/index';

const mm2point = form => form.map(dim => dim * 2.835);

function text(doc, val, { size = 16, x = 5, y }) {
  doc.setFontSize(size);
  doc.text(x, y, val);
}

export default (JsPDF, { name, company, visit: { level }, size = [84, 62] }) => {
  const [width, height] = size;
  const center = height / 2;

  const doc = new JsPDF({
    orientation: 'landscape',
    format: mm2point(size),
  });

  doc.rect(0, 0, width, 12, 'F');
  doc.setTextColor(255, 255, 255);
  const headline = (level === 2) ? messages.de.login.worker : messages.de.login.visitor;
  text(doc, headline, { y: 8 });

  doc.setTextColor(0);

  text(doc, name, { y: center });

  text(doc, company, { size: 12, y: center + 8 });

  text(doc, format(new Date(), 'dd.MM.yyyy HH:mm \'Uhr\''), { size: 8, y: height - 4 });

  return doc;
};
